import appRide from "../../views/appRoutes/ride.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("ride", {
    url: "ride/:id",
    parent: "app",
    views: {
      view: {
        template: appRide,
      },
    },
    data: { title: "Ride" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/ride/ride.urls.js